import { __rest } from "tslib";
import React from 'react';
import { cn } from '~/utils';
import { menuItem } from './menu-item.css';
const MENU_ITEM_NAME = 'vulcanui-menu-item';
function MenuItem(props) {
    const { className, children, startContent, disabled, as: Comp = 'li', readOnly } = props, restProps = __rest(props, ["className", "children", "startContent", "disabled", "as", "readOnly"]);
    return (React.createElement(Comp, Object.assign({ "aria-disabled": disabled, "aria-readonly": readOnly, role: "menuitem", className: cn(MENU_ITEM_NAME, className, menuItem({ isDisabled: disabled, readOnly })) }, restProps),
        startContent,
        children));
}
MenuItem.displayName = 'Menu.Item';
MenuItem.toString = () => `.${MENU_ITEM_NAME}`;
export default MenuItem;
//# sourceMappingURL=menu-item.js.map